<div class="analytics-dashboard">
    <!-- Period Selector -->
    <div class="period-bar">
        <div class="period-buttons">
            <button *ngFor="let p of periods"
                    class="period-button"
                    [class.active]="selectedPeriod === p.value"
                    (click)="onPeriodChange(p.value)">
                {{ p.labelKey | translate }}
            </button>
        </div>

        <div class="custom-dates" *ngIf="showCustomDates">
            <label class="date-label">{{ 'request_v2.analytics.from' | translate }}</label>
            <input type="date" [(ngModel)]="customFrom" (change)="onCustomDateChange()" class="date-input">
            <label class="date-label">{{ 'request_v2.analytics.to' | translate }}</label>
            <input type="date" [(ngModel)]="customTo" (change)="onCustomDateChange()" class="date-input">
        </div>

        <mat-form-field class="department-filter" appearance="outline" *ngIf="departments.length > 0">
            <mat-label>{{ 'request_v2.analytics.filter_departments' | translate }}</mat-label>
            <mat-select multiple [value]="selectedDepartments" (selectionChange)="onDepartmentChange($event.value)">
                <mat-option *ngFor="let dept of departments" [value]="dept._id">
                    {{ dept.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <label class="compare-toggle">
            <input type="checkbox" [checked]="comparePrevious" (change)="onCompareToggle()">
            {{ 'request_v2.analytics.compare_previous' | translate }}
        </label>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="loading-state">
        <mat-spinner diameter="40"></mat-spinner>
        <p>{{ 'request_v2.analytics.loading' | translate }}</p>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="error-state">
        <mat-icon>error_outline</mat-icon>
        <p>{{ 'request_v2.analytics.error' | translate }}</p>
        <button class="retry-button" (click)="retry()">{{ 'request_v2.analytics.retry' | translate }}</button>
    </div>

    <!-- Dashboard Content -->
    <div *ngIf="!loading && !error && snapshot" class="dashboard-content">
        <app-analytics-kpi-cards
            [snapshot]="snapshot"
            [comparePrevious]="comparePrevious">
        </app-analytics-kpi-cards>

        <!-- Row 1: Full-width — Performance by service -->
        <div class="charts-row-full">
            <app-analytics-performance-table
                [data]="performance?.items || []"
                [comparePrevious]="comparePrevious">
            </app-analytics-performance-table>
        </div>

        <!-- Row 2: Two-column — Status breakdown + Category breakdown -->
        <div class="charts-row-2col">
            <app-analytics-status-chart
                [data]="distribution?.byStatus || []"
                [total]="distribution?.total || 0">
            </app-analytics-status-chart>

            <app-analytics-category-chart
                [data]="distribution?.byCategory || []"
                [colorMap]="categoryColorMap">
            </app-analytics-category-chart>
        </div>

        <!-- Row 2: Two-column — SLA trend + Volume trend -->
        <div class="charts-row-2col">
            <app-analytics-trend-chart
                [title]="'request_v2.analytics.sla_trend_title'"
                [currentData]="trends?.slaCompliance?.current || []"
                [previousData]="trends?.slaCompliance?.previous"
                [valueField]="'rate'"
                [color]="'#10b981'"
                [targetLine]="95">
            </app-analytics-trend-chart>

            <app-analytics-trend-chart
                [title]="'request_v2.analytics.volume_trend_title'"
                [currentData]="trends?.requestVolume?.current || []"
                [previousData]="trends?.requestVolume?.previous"
                [valueField]="'count'"
                [color]="'#1976d2'">
            </app-analytics-trend-chart>
        </div>

        <!-- Row 4: Full-width — Heatmap -->
        <div class="charts-row-full">
            <app-analytics-heatmap
                [points]="geo?.points || []"
                [categories]="categoryList">
            </app-analytics-heatmap>
        </div>
    </div>
</div>
